'use client';

import { c as _c } from "react/compiler-runtime";
import { useUAContext } from '@/context/UAContext';
import { enterFullscreen } from '@/lib/fullscreen';
import { useCallback, useEffect, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
type UseAutoFullscreenProps = {
  targetId: string;
  enableModal: boolean;
};
export function useAutoFullscreen(t0) {
  const $ = _c(15);
  const {
    targetId,
    enableModal
  } = t0;
  const {
    device
  } = useUAContext();
  const [showModal, setShowModal] = useState(false);
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const isMobileBrowser = device === "mobile_browser";
  let t1;
  if ($[0] !== enableModal || $[1] !== targetId) {
    t1 = async () => {
      if (document.fullscreenElement) {
        return;
      }
      try {
        await enterFullscreen(targetId);
      } catch {
        if (enableModal) {
          setShowModal(true);
        }
      }
    };
    $[0] = enableModal;
    $[1] = targetId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tryFullscreen = t1;
  let t2;
  if ($[3] !== targetId) {
    t2 = async () => {
      setShowModal(false);
      ;
      try {
        await enterFullscreen(targetId);
      } catch (t3) {
        const error = t3;
        console.error("[useAutoFullscreen] onConfirm", error);
      }
    };
    $[3] = targetId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onConfirm = t2;
  let t3;
  let t4;
  if ($[5] !== isLandscape || $[6] !== isMobileBrowser || $[7] !== targetId || $[8] !== tryFullscreen) {
    t3 = () => {
      const target = document.getElementById(targetId);
      if (!isMobileBrowser || typeof target?.requestFullscreen !== "function") {
        return;
      }
      if (isLandscape) {
        tryFullscreen();
      } else {
        setShowModal(false);
      }
    };
    t4 = [isLandscape, isMobileBrowser, targetId, tryFullscreen];
    $[5] = isLandscape;
    $[6] = isMobileBrowser;
    $[7] = targetId;
    $[8] = tryFullscreen;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  if (!isMobileBrowser) {
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        showModal: false,
        onConfirm: _temp
      };
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== onConfirm || $[13] !== showModal) {
    t5 = {
      showModal,
      onConfirm
    };
    $[12] = onConfirm;
    $[13] = showModal;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp() {}